/* Description expansion only; deliberately leaves product/cart JavaScript untouched. */
(function () {
  function setup(root) {
    if (!root) return;
    var copy = root.querySelector('[data-redcamp-description]');
    var button = root.querySelector('[data-redcamp-description-toggle]');
    if (!copy || !button) return;
    if (button.dataset.redcampReady === 'true') return;
    button.dataset.redcampReady = 'true';

    var label = button.querySelector('[data-redcamp-more-text]');
    function update() {
      // The mobile accordion keeps this content hidden until its own button opens.
      // Recalculate the desktop preview when returning from mobile width.
      if (window.matchMedia('(max-width: 768px)').matches) return;
      if (copy.classList.contains('is-expanded')) return;
      // Preserve the first two description paragraphs when present.
      var paragraphs = Array.prototype.filter.call(copy.querySelectorAll('p'), function (p) {
        return p.textContent.trim().length > 0 || p.querySelector('img, video, iframe');
      });
      if (paragraphs.length >= 2) {
        var h = Math.ceil(paragraphs[1].getBoundingClientRect().bottom - copy.getBoundingClientRect().top + 4);
        if (h > 0) copy.style.setProperty('--redcamp-details-preview-height', h + 'px');
      }
      button.hidden = (copy.scrollHeight <= copy.clientHeight + 2);
    }
    button.addEventListener('click', function () {
      var expanded = copy.classList.toggle('is-expanded');
      // Keep expanded content at natural height. Fixed pixel heights clip long
      // product descriptions and late-loading images.
      if (expanded) {
        copy.style.height = 'auto';
        copy.style.maxHeight = 'none';
        copy.style.overflow = 'visible';
      } else {
        copy.style.removeProperty('height');
        copy.style.removeProperty('max-height');
        copy.style.removeProperty('overflow');
        update();
      }
      button.setAttribute('aria-expanded', String(expanded));
      if (label) label.textContent = expanded ? 'Show less' : 'Show more';
    });
    update();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    window.addEventListener('resize', function () { requestAnimationFrame(update); }, { passive: true });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-redcamp-details-section]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
